export function TOGGLE_LEFT_MENU(boolean) {
	return {
		type: 'TOGGLE_LEFT_MENU',
		payload: boolean,
	};
}
